<template>
  <el-table-column align="center" label="认领歌单信息">
    <el-table-column label="歌单ID" width="120" prop="tracklistId"></el-table-column>
    <el-table-column label="歌单信息" width="310" v-slot="{ row }">
      <track-info-mod :data="row"></track-info-mod>
    </el-table-column>
    <el-table-column label="作品链接" width="120" prop="appealUrl"></el-table-column>
  </el-table-column>
</template>

<script>
import TrackInfoMod from './TrackInfoMod.vue'

export default {
  name: 'NoticeInfoCol',
  components: {
    TrackInfoMod
  }
}
</script>
